export default __webpack_public_path__ + "static/media/vericlock.98a8ed29.png";